import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
// import { Menu2 } from 'app/Shared/models/menu.model';

@Component({
  selector: 'dynamic-sidebar-item',
  templateUrl: './dynamic-sidebar-item.component.html',
  styleUrls: ['./dynamic-sidebar-item.component.css']
})
export class DynamicSidebarItemComponent implements OnInit {

  // @Input() menu!: Menu2;
  @Input() menu!: any;

  isExpanded: boolean = false;

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  toggleSubMenu() {
    this.isExpanded = !this.isExpanded;
  }

  navigateToMenu(url: string): void {
    if (url) {
      if (url.startsWith('http')) {
        window.location.href = url;
      } else {
        this.router.navigateByUrl(url);
      }
    }
  }
}
